module.exports = __webpack_public_path__ + "static/media/adBlock.63613aca.svg";